import React, { useEffect,useState } from "react";
import HomeBannerAbout from "./HomeBannerAbout";
import HomeBannerMobile from "./HomeBannerMobile";
import HomeBannerDesktop from "./HomeBannerDesktop";
import HomebackBannerDesktop from "./HomebackBannerDesktop";
import { fetchbannerlistmo } from "../services/HomeBannerMobilelist";
import { fetchbannerlistdesk } from "../services/HomeBannerdesklist";
import { API_BASE } from "../api/apiConfig";


export default function HomeBanner() {
  const [cards, setCards] = useState([]);
  const [activeCard, setActiveCard] = useState(0);

  const GraduationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-graduation-cap h-4.5 w-4.5"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-4.5 w-4.5"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
);

const GlobeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe h-4.5 w-4.5"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>
);

   const configMap = {
    "Skill-Building": {
      icon: <GraduationIcon />,
      subtitle: "Skill-Building",
      cta: "Learn While You Travel",
      href: "/ExperienceTrips",
    },
    "Adventures": {
      icon: <UsersIcon />,
      subtitle: "Adventures",
      cta: "Find Your Tribe",
      href: "/grouptrips",
    },
    "Free to Join": {
      icon: <GlobeIcon />,
      subtitle: "Free to Join",
      cta: "Connect Locally",
      href: "/community",
    },
  };

   // ✅ API CALL (ONLY HERE)
  useEffect(() => {
    const loadBanners = async () => {
      const isMobile = window.innerWidth < 1024;

      const res = isMobile
        ? await fetchbannerlistmo()
        : await fetchbannerlistdesk();

      if (res?.status && Array.isArray(res.data)) {
        const formatted = res.data
          .filter(item => configMap[item.page_name])
          .map(item => {
            const config = configMap[item.page_name];

            return {
              id: item.id,
              title: item.heading,
              desc: item.paragraph,
              img: `${API_BASE}/${item.banner_img}`,
              ...config,
            };
          });

        setCards(formatted);
      }
    };

    loadBanners();
  }, []);

  return (

    <section className="relative w-full bg-white lg:bg-slate-950 overflow-hidden">

      {/* ================= DESKTOP BACKGROUND ================= */}


      <HomebackBannerDesktop activeCard={activeCard} cards={cards} />


      {/* ================= MOBILE VIEW ================= */}
      
      <HomeBannerMobile />

      {/* ================= DESKTOP CONTENT ================= */}
      
      <HomeBannerDesktop activeCard={activeCard} 
        setActiveCard={setActiveCard} />





    </section>
  );
}
